import { useEffect, useState } from "react";
import { LifeBuoy, Send } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { toast } from "sonner";

export default function Assistance() {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [tickets, setTickets] = useState([]);

  const load = () => api.mySupport().then(({ data }) => setTickets(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.support({ subject, message });
      toast.success("Message envoyé à l'assistance.");
      setSubject(""); setMessage(""); load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
      <h1 className="flex items-center gap-2 font-serif text-3xl text-celeste-ivoire"><LifeBuoy className="h-6 w-6 text-celeste-or" /> Assistance & litiges</h1>
      <p className="mt-2 text-sm text-celeste-lilas/75">Une question, un litige sur une consultation ? Notre équipe de modération vous répond.</p>

      <form onSubmit={submit} className="glass mt-6 space-y-4 rounded-3xl border border-celeste-or/15 p-6">
        <Input data-testid="support-subject" required value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Objet de votre demande" className="bg-celeste-night/50 border-celeste-violet/30 text-celeste-ivoire" />
        <Textarea data-testid="support-message" required value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Décrivez votre demande…" className="min-h-32 bg-celeste-night/50 border-celeste-violet/30 text-celeste-ivoire" />
        <Button data-testid="support-submit" type="submit" className="gold-btn font-semibold"><Send className="mr-1.5 h-4 w-4" /> Envoyer</Button>
      </form>

      {tickets.length > 0 && (
        <div className="mt-8 space-y-3">
          <h2 className="font-serif text-xl text-celeste-ivoire">Mes demandes</h2>
          {tickets.map((t) => (
            <div key={t.id} className="glass rounded-2xl p-4">
              <div className="flex items-center justify-between">
                <p className="text-celeste-ivoire">{t.subject}</p>
                <span className="rounded-full bg-celeste-violet/20 px-2 py-0.5 text-xs text-celeste-lilas">{t.status}</span>
              </div>
              <p className="mt-1 text-sm text-celeste-lilas/70">{t.messages?.[0]?.text}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
